import { useFetchByIds } from "services/common";
import { characterConverter } from "db/converters";
import { COLLECTION_NAME } from ".";

/**
 *
 * Hook personalizado para obtener personajes basadas en una lista de IDs.
 * Este hook realiza una consulta a la colección de personajes
 * y devuelve las personajes correspondientes.
 * @param {Array} characterIds - Lista de IDs de personajes a buscar.
 *
 * @returns {Object} - Un objeto que contiene:
 * - `characters`: Un array de personajes obtenidas.
 * - `loading`: Un booleano que indica si la consulta está en curso.
 * - `error`: Un objeto de error si ocurrió un problema durante la consulta.
 *
 */
export const useFetchCharactersByIds = (characterIds = []) => {
  const { data, loading, error } = useFetchByIds(
    COLLECTION_NAME,
    characterIds,
    characterConverter
  );
  return { characters: data, loading, error };
};
